import * as React from "react"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout"
import Img from "gatsby-image"

const seo = {
    title: "About VibraHub",
    description: "VibraHub designs and builds soundproof booths and pods that give open-plan offices quiet space without building work. Designed in Europe, delivered across the UK and the EU.",
}

const AboutUs = ({ data }) => {
    return (
        <Layout seo={seo}>
            <div className="site-wrapper-reveal border-bottom">

                <div className="featuted-product-wrap section-space--pt_120">
                    <div className="container">
                        <div className="row align-items-center featuted-product-one">
                            <div className="col-lg-6 col-md-6 order-lg-2 order-1">
                                <div className="product-thumbnail">
                                    <Img fluid={data.aboutUsImage.childImageSharp.fluid} alt="Vibra booth in an office"></Img>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 order-lg-1 order-2">
                                <div className="featured-product-contect">
                                    <h3 className="section-title">About us</h3>
                                    <p className="section-space--mt_60">
                                        Vibra started with a familiar problem: a good team in an open-plan office, and nowhere to take a call. Meeting rooms were always booked, headphones did not stop the person at the next desk from hearing everything, and building extra rooms meant landlords, contractors and months of disruption.
                                    </p>
                                    <p>
                                        We design and build booths and pods that solve that without touching the building. They stand on the floor, plug into a socket and can move with you to the next office. Our team works from Slovenia and the United Kingdom, and we deliver across the UK and the EU.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="featuted-product-wrap section-space--pt_120">
                    <div className="container">
                        <div className="row align-items-center featuted-product-one">
                            <div className="col-lg-6 col-md-6 order-lg-1 order-1">
                                <div className="product-thumbnail">
                                    <Img fluid={data.designImage.childImageSharp.fluid} alt="Vibra design sketches"></Img>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 order-lg-2 order-2">
                                <div className="featured-product-contect">
                                    <h3 className="section-title">How we design</h3>
                                    <h6 className="section-space--mt_60">Furniture, not construction</h6>
                                    <p>
                                        We follow the Bauhaus idea that furniture should complement the architecture around it rather than compete with it. A Vibra booth is meant to sit in your office like a good piece of furniture: quiet in appearance, obvious in purpose, and easy to live with.
                                    </p>

                                    <h6>Tested with real people</h6>
                                    <p>
                                        Every design is used in a working office before it ships. Ventilation, light levels, the feel of the door and the sound of your own voice inside are things you cannot judge from a drawing, so we do not.
                                    </p>

                                    <h6>Honest numbers</h6>
                                    <p>
                                        Acoustic figures are easy to inflate. We explain what the measurements mean in our <Link to="/guides/how-much-sound-insulation-does-a-phone-booth-need/">guide to booth sound insulation</Link>, and we would rather you sat in a booth for twenty minutes than trusted a number on a brochure.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="featuted-product-wrap section-space--ptb_120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 mx-auto text-center">
                                <h3 className="section-title">Talk to us</h3>
                                <p className="section-space--mt_20">Whether you need one booth or a plan for a whole floor, start with a conversation.</p>
                                <div className="button-box section-space--mt_40">
                                    <Link to="/contact-us/" className="text-btn-normal">Contact us <i className="icon-arrow-right"></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </Layout>
    )
}

export const query = graphql`
  query {
    designImage: file(relativePath: { eq: "about-us/design.png" }){
        childImageSharp {
            fluid(maxWidth: 600) {
                ...GatsbyImageSharpFluid_noBase64
            }
        }
    }
    aboutUsImage: file(relativePath: { eq: "about-us/aboutUs.jpeg" }){
        childImageSharp {
            fluid(maxWidth: 600) {
                ...GatsbyImageSharpFluid_noBase64
            }
        }
    }
  }`

export default AboutUs
